<template>
  <div>
    <!--    待分配非企微客户-->
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :other-params= "{'userId':userId}"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <div class="btns_box" style="padding: 20px 0;">
          <vxe-button @click="showAssignPopFunc">
            分配
          </vxe-button>
        </div>
      </template>
    </x-grid>


    <!-- 选择分配人 弹窗 -->
    <a-modal
        title="选择分配人"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="true"
        v-model="showAssignPop"
        :width="1200"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <sonDeptUsersList
          :assignIdArr="assignIdArr"
          :type="2"
          v-if="showAssignPop"
          ref="sonDeptUsersList"
          @closeParent="closeDetailPop"
          @openParent="openDetailPop"
          @close="closePop"
      >
      </sonDeptUsersList>
    </a-modal>

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";


import sonDeptUsersList from "./inheritUsersList";
console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错


//列表接口 - 带部门权限的成员列表接口
const url = api.client.INHERIT + '/getUserUnAssignCust';

//主键
const rowId = 'custId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("custName", "客户名称", 'auto', 'center'),
  fac.makeColumn("custNatureName", "客户性质", 'auto', 'center'),
  fac.makeColumn("mobile", "联系电话", 'auto', 'center'),
  fac.makeColumn("userName", "共享人", 'auto', 'center'),
  fac.makeColumn("regionName", "经销商", 'auto', 'center'),
  fac.makeColumn("dealerName", "经理部", 'auto', 'center'),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'custName'},
  {field: 'custNatureName'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  // props: ['assignIdArr'],
  props: ['userId'],
  components: {
    sonDeptUsersList
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      showAssignPop:false,
      assignIdArr:[], //将选中的客户（多选）分配给分配人（单选）
      editRowId: -1,
    }
  },
  mounted() {
    console.log(136,this.userId);
  },
  methods: {
    loadBaseData,

      closeDetailPop(){
        this.$emit('closeParent')
      },
      openDetailPop(){
        this.$emit('openParent')
      },
      // showAssignPopFunc() {
      //   this.refresh();
      // },
      reloadSonTable() {
        this.refresh();
      },
      // 弹出分配人列表 选择分配人进行分配
      showAssignPopFunc(row) {
        //判断操作 是批量还是单条数据
        if (!row.custId) { //批量
          let rowArr = this.getRows();
          if (!rowArr.length) {
            this.$message.error('请选择一条数据');
            return false;
          } else {
            let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
            this.assignIdArr = rowResult.map(item => item.custId);
            this.showAssignPop = true;
          }
        } else {  //单条数据
          this.assignIdArr.push(row.custId);
          this.showAssignPop = true;
        }
      },
      // 关闭弹窗
      closePop() {
        this.showAssignPop = false; //分配人列表
        this.refresh();
      },
    }

}
</script>

<style scoped>

/deep/ .vxe-table--body-wrapper {
  height: 300px !important;
}

/deep/ .vxe-table--empty-placeholder {
  height: 300px !important;
}

</style>
